'use client'

import { getBalance } from '@/actions/wallet'
import useAppStore from '@/core/stores/app'
import { useUserStore } from '@/core/stores/user'
import Cookies from 'js-cookie'
import { useEffect } from 'react'

import { getFavorite } from '@/actions/hotels/favorite'
import { useState } from "react"
import { decodeToken } from '@/utils/deCodeJwtToken'

export default function MainClientDataSetter() {

    const [showUser, setShowUser] = useState(false)

    const hasUserToken = Cookies.get('ut')
    const decodedToken = hasUserToken ? decodeToken(hasUserToken) : ''
    let hasValidToken = false
    if (decodedToken) {
        if (decodedToken.exp * 1000 > new Date().getTime()) {
            hasValidToken = true
        } else {
            Cookies.remove('ut')
        }
    } else {
        Cookies.remove('ut')
    }

    const { fetchUserProfile, email, setIsGettingProfile, setFavoriteActivities, setFavoriteHotelsDetails, setWalletBalance } = useUserStore()



    const handleGetFavorites = async () => {
        const res = await getFavorite()
        const { response, result } = JSON.parse(res)
        if (response.ok && result && result.hotels) {
            setFavoriteHotelsDetails(JSON.parse(res).result.hotels)
        }
    }

    const handleGetUserBallance = async () => {
        const res = await getBalance()

        const { result, response } = JSON.parse(res)

        if (response.ok) {
            // setShowUser(true)
            setWalletBalance(result.balance)
        } else {
            setShowUser(true)
        }
    }

    const { setAppHeight, setAppWidth, } = useAppStore()

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setAppHeight(window.innerHeight)
            setAppWidth(window.innerWidth)

        }
    }, [])


    useEffect(() => {


        if (!showUser && (hasValidToken)) {
            fetchUserProfile()
            handleGetFavorites()
            // handleGetFavoritesActivities()
            handleGetUserBallance()
        } else {
            setIsGettingProfile(false)
        }
    }, [hasValidToken, email])

    return null
}